import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  DigitalWrapperSelection,
  RecipientExperiencePreview,
  ReviewSection
} from '@hero/molecules';

import * as S from './style';

export function RecipientExperienceSection({
  errors,
  giftWrapperUrl,
  linkPreview,
  logoUrl,
  message,
  senderName,
  onMessageParams,
  onBranding,
  isContactLess,
  stepIndex = 3,
  isCompleted = false
}) {
  const { t } = useTranslation();

  return (
    <ReviewSection
      stepIndex={stepIndex}
      isCompleted={isCompleted}
      title={t('recipientExperienceTitle')}
      subTitle={t('recipientExperienceDesc')}
    >
      <S.RECBody>
        <RecipientExperiencePreview
          errors={errors}
          giftWrapperUrl={giftWrapperUrl}
          isContactLess={isContactLess}
          linkPreview={linkPreview}
          logoUrl={logoUrl}
          message={message}
          senderName={senderName}
          onMessageParams={onMessageParams}
          onBranding={onBranding}
        />
        <DigitalWrapperSelection giftWrapperUrl={giftWrapperUrl} onBranding={onBranding} />
      </S.RECBody>
    </ReviewSection>
  );
}

RecipientExperienceSection.propTypes = {
  errors: PropTypes.shape({
    senderName: PropTypes.bool,
    message: PropTypes.bool
  }),
  giftWrapperUrl: PropTypes.string,
  isLoading: PropTypes.bool,
  linkPreview: PropTypes.string,
  logoUrl: PropTypes.string,
  message: PropTypes.string,
  onMessageParams: PropTypes.func.isRequired,
  onBranding: PropTypes.func.isRequired,
  senderName: PropTypes.string,
  isContactLess: PropTypes.bool,
  stepIndex: PropTypes.number,
  isCompleted: PropTypes.bool
};
